import { render } from "./BlogSidebar.vue?vue&type=template&id=6306d26a&ts=true"
import script from "./BlogSidebar.vue?vue&type=script&lang=ts"
export * from "./BlogSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__